import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { UserAuthService } from "src/services/user-auth.service";

@Component({
  selector: "app-on-boarding-slider",
  templateUrl: "./on-boarding-slider.component.html",
  styleUrls: ["./on-boarding-slider.component.scss"],
  standalone: false,
})
export class OnBoardingSliderComponent {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private userAuthService: UserAuthService
  ) {}

  skipLogin() {
    this.userAuthService.setSkipLogin();
    const redirectTo =
      this.route.snapshot.queryParamMap.get("redirectTo") ?? "/dashboard";
    this.router.navigate([redirectTo]);
  }
}
